<template>
  <popup class="insights-feedback-popup" :close-action="closeActionClicked" :buttons="buttons">
    <template v-slot:content>
      <insight-feedback @thumbs-up="thumbsUp" @thumbs-down="thumbsDown"/>
    </template>
  </popup>
</template>

<script>
import Segment from '@/Segment';
import BaseUI from 'base-ui';
import InsightFeedback from '@/base-components/InsightFeedback';

export default {
  name: 'InsightFeedbackPopup',
  props: {
    insight: { type: Object, required: true },
  },
  components: {
    InsightFeedback,
    Popup: BaseUI.Popup,
  },
  async created() {
    Segment.trackUserInteraction('InsightFeedbackPopupOpened', this.insight);
  },
  computed: {
    buttons() {
      return [
        {
          title: 'סגור',
          variant: 'primary',
          action: this.closeActionClicked,
        },
      ];
    },
  },
  methods: {
    closeActionClicked() {
      Segment.trackUserInteraction('InsightFeedbackPopupClosed', this.insight);
      this.closePopup();
    },
    thumbsUp() {
      Segment.trackUserInteraction('InsightFeedbackPopupThumbsUp', { ...this.insight });
    },
    thumbsDown() {
      Segment.trackUserInteraction('InsightFeedbackThumbsDown', { ...this.insight });
    },
    closePopup() {
      this.$emit('close');
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .insights-feedback-popup {
  }
</style>
